module.exports = __webpack_public_path__ + "static/daniel-af7891ecbcbc3957e0563a15de67906e.png";